<template>
  <div class="newsMain">
    <!-- 时空电子商务平台 -->
    <PcCommerce class="PC"/>
    <MdCommerce class="MD"/>
  </div>
</template>

<script>
// 移动端
import MdCommerce from './MdCommerce.vue'
// pc端
import PcCommerce from './PcCommerce.vue'
export default {
  name: 'newsMain',
  components: {
    PcCommerce,
    MdCommerce
  }
}
</script>

<style lang="scss" scoped>
// 移动
@media only screen and (max-width: 750px) {
  .newsMain{
    .PC{
      display: none;
    }
  }

}
// PC端/
@media only screen and (min-width: 756px) {
  .newsMain{
    .MD{
      display: none;
    }
  }
}
</style>
